document.addEventListener('DOMContentLoaded', () => {
	const images = document.querySelectorAll('.zoom-scroll-image');

	images.forEach((image) => {
		let currentScrollTarget = document; // track which element has the listener

		const updateZoom = () => {
			const rect = image.getBoundingClientRect();

			let imageCenter, viewportCenter, maxDistance;

			// vertical mode
			imageCenter = rect.top + rect.height / 2;
			viewportCenter = window.innerHeight / 2;
			maxDistance = viewportCenter;

			const distance = Math.abs(viewportCenter - imageCenter);
			const scale = 1.2 - Math.min(distance / maxDistance, 1) * 0.1;
			image.style.transform = `scale(${scale})`;
		};

		const bindListeners = () => {
			currentScrollTarget.addEventListener('scroll', updateZoom, {
				passive: true,
			});

			updateZoom();
		};

		// on resize, rebind
		window.addEventListener('resize', bindListeners);

		// initial bind
		bindListeners();
	});
});
